import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import SelectBox from '@welldev-group/rcl-select-box';
import { Text } from '@welldev-group/rcl-typography';
import { CheckBox, I18nText } from '@welldev-group/react-comp-lib';

import selectBoxObjectMapper from '../../../shared/helper/selectBoxObjectMapper';

const PermissionsSelection = ({
  permissionTemplateOptions,
  permissionOptions,
  selectedPermissions,
  onChange,
}) => {
  const [permissionTemplate, setPermissionTemplate] = useState(null);

  useEffect(() => {
    onChange(selectedPermissions);
  }, [selectedPermissions]);

  const permissionTemplates = permissionTemplateOptions.map(
    permissionTemplateOption => ({
      value: permissionTemplateOption.key,
      label: I18n.t(permissionTemplateOption.key, {
        scope: 'permission_templates',
      }),
    }),
  );

  const onPermissionTemplateChange = selectedOption => {
    if (selectedOption) {
      const chosenTemplate = permissionTemplateOptions.find(
        option => option.key === selectedOption.value,
      );
      onChange(chosenTemplate.permissions);
      setPermissionTemplate(selectedOption.value);
    } else {
      onChange([]);
      setPermissionTemplate(null);
    }
  };

  const renderPermissionCheckboxes = app => {
    const renderCheckbox = scope => {
      const permission = `${app}:${scope}`;

      return (
        <div className="col-12 col-bleed-y" key={scope}>
          <CheckBox
            label={I18n.t(`permissions.${app}.${scope}`)}
            name={`permission-${app}-${scope}`}
            onChange={(_event, checked) => {
              let newPermissions = [];
              if (checked) {
                newPermissions = [...selectedPermissions, permission];
              } else {
                newPermissions = selectedPermissions.filter(
                  item => item !== permission,
                );
              }
              onChange(newPermissions);
              setPermissionTemplate(null);
            }}
            checked={selectedPermissions.indexOf(permission) >= 0}
            value={scope}
          />
        </div>
      );
    };

    return (
      <div>
        <div className="col-12 col-bleed-y">{I18n.t(`apps.${app}`)}</div>
        {permissionOptions[app].map(renderCheckbox)}
      </div>
    );
  };

  return (
    <>
      <div className="col-12">
        <Text level="1" weight="bold" isInline={true}>
          <I18nText id="user.form.select_access_rights" />
        </Text>
      </div>
      <div className="col-12 col-bleed-y">
        <SelectBox
          name="permissionTemplate"
          onChange={onPermissionTemplateChange}
          options={permissionTemplates}
          placeholderText={<I18nText id="user.form.permission_template" />}
          width="full"
          value={selectBoxObjectMapper(permissionTemplates, permissionTemplate)}
        />
      </div>
      <div className="col-grid col-bleed direction-row">
        <div className="col-lg-6 col-sm-12 col-bleed">
          <div className="col-12 col-bleed-x">
            {renderPermissionCheckboxes('affiliates')}
          </div>
        </div>
        <div className="col-lg-6 col-sm-12 col-bleed-x">
          {renderPermissionCheckboxes('agent')}
        </div>
      </div>
    </>
  );
};

PermissionsSelection.defaultProps = {
  selectedPermissions: [],
};

PermissionsSelection.propTypes = {
  onChange: PropTypes.func.isRequired,
  permissionOptions: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string))
    .isRequired,
  permissionTemplateOptions: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      permissions: PropTypes.arrayOf(PropTypes.string).isRequired,
    }),
  ).isRequired,
  selectedPermissions: PropTypes.arrayOf(PropTypes.string),
};
export default PermissionsSelection;
